<span class="snackbar">
  <ng-container *ngIf="!data?.text; else textBlock">{{
    (data?.title ? data?.title! : 'ERROR.TITLE') | translate
  }}</ng-container>
  <ng-template #textBlock>{{ data?.text }}</ng-template>
</span>
